import React from 'react'
import { useAppSelector } from 'reduxTyped'
import { l } from '@manychat/manyui'

import { IButton, ICallButton, IURLButton } from 'common/builder/buttons/buttonInterfaces'
import { BlockType } from 'common/builder/constants/BlockType'
import builderSelectors from 'common/builder/selectors/builder'
import * as entitySelectors from 'common/builder/selectors/builder/entitySelectors'

import { StatsViewer } from '../StatsViewer/StatsViewer'

interface ButtonStatsViewerProps {
  builderId: string
  button: IButton
}

export const ButtonStatsViewer = ({ button, builderId }: ButtonStatsViewerProps) => {
  const { isSimple, deliveredUniqueUsers } = useAppSelector(
    (state) => builderSelectors.builderState.getById(state, builderId).config,
  )

  const parentBlock = useAppSelector((state) =>
    entitySelectors.getParentBlock(state, builderId, button.id),
  )

  if (parentBlock && parentBlock.type === BlockType.CARD && parentBlock.isCardHidden) {
    return <div className="p-a">{l.translate('Unable to show statistics for hidden card')}</div>
  }

  return (
    <StatsViewer
      builderId={builderId}
      phone={(button as ICallButton).phone}
      url={(button as IURLButton).url}
      stats={button.stats}
      isSimple={isSimple}
      deliveredUniqueUsers={deliveredUniqueUsers}
    />
  )
}
